import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import PrintBarcode from "./PrintBarcode";
import ScanBarcode from "./ScanBarcode";

function Dashboard() {
  const Status = useSelector(
    (state) => state.scan.ScanPrintStatsToggleStatus
  );
  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Scan/Print barcodes
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        
       
        <ToggleDetails />
        {Status === "Scan Barcode" ? <ScanBarcode /> : null}
        {Status === "Print barcodes" ? <PrintBarcode /> : null}
      </div>
    </>
  );
}

export default Dashboard;
